import { useMemo, useState } from "react";
import PackageCard from "@/components/PackageCard";
import { FullLoader } from "@/components/ProtectedRoute";
import { useApi } from "@/hooks/useApi";
import { useSettings } from "@/context/SettingsContext";

export default function Programs() {
  const { data, loading } = useApi("/packages");
  const [cat, setCat] = useState("Semua");
  const { settings } = useSettings();
  const cats = useMemo(() => ["Semua", ...new Set((data || []).map((p) => p.category))], [data]);
  const list = (data || []).filter((p) => cat === "Semua" || p.category === cat);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="programs-page">
      <p className="eyebrow">Program Belajar</p>
      <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900" data-testid="programs-title">{settings?.programs_title}</h1>
      <p className="mt-5 text-slate-600 max-w-2xl" data-testid="programs-description">{settings?.programs_description}</p>
      <div className="mt-10 flex flex-wrap gap-2">
        {cats.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-200 ${cat === c ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}
            data-testid={`program-filter-${c.toLowerCase().replace(/[^a-z]/g, "-")}`}
          >
            {c}
          </button>
        ))}
      </div>
      {loading ? <FullLoader /> : (
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((p) => <PackageCard key={p.id} pkg={p} />)}
        </div>
      )}
    </div>
  );
}
